import { Reducer } from 'redux'
import { MerchantsChannelsState, MerchantsChannelsTypes } from './types'
import { AuthActionTypes } from '../auth'

export const initialState: MerchantsChannelsState = {
  merchantChannelError: undefined,
  merchantChannelExportError: undefined,
  exportStream: undefined,
  isExportError: false,
  isExportSuccess: false,
  isExporting: false,
  loading: false,
  channels: null
}

const reducer: Reducer<MerchantsChannelsState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case MerchantsChannelsTypes.VIEW_MERCHANT_CHANNEL_PAYMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        channels: null,
        merchantChannelError: undefined,
        merchantChannelExportError: undefined
      }
    case MerchantsChannelsTypes.VIEW_MERCHANT_CHANNEL_PAYMENTS_SUCCESS:
      return {
        ...state,
        channels: action.payload,
        loading: false,
        merchantChannelError: undefined
      }
    case MerchantsChannelsTypes.VIEW_MERCHANT_CHANNEL_PAYMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        channels: null,
        merchantChannelError: action.payload
      }

    case MerchantsChannelsTypes.CLEAR_CHANNELS:
      return {
        ...state,
        channels: null,
        merchantChannelError: undefined,
        merchantChannelExportError: undefined
      }
    case MerchantsChannelsTypes.EXPORT_MERCHANT_CHANNEL_PAYMENTS_REQUEST:
      return {
        ...state,
        isExporting: true,
        merchantChannelExportError: undefined
      }
    case MerchantsChannelsTypes.EXPORT_MERCHANT_CHANNEL_PAYMENTS_SUCCESS:
      return {
        ...state,
        isExporting: false,
        exportStream: action.payload,
        isExportError: false,
        isExportSuccess: true,
        merchantChannelExportError: undefined
      }
    case MerchantsChannelsTypes.EXPORT_MERCHANT_CHANNEL_PAYMENTS_FAILURE:
      return {
        ...state,
        isExporting: false,
        exportStream: undefined,
        isExportError: true,
        isExportSuccess: false,
        merchantChannelExportError: action.payload
      }

    case AuthActionTypes.DESTROY_STATES:
      return initialState
    default:
      return state
  }
}

export { reducer as channelsReducer }
